module.exports = "@media (max-width: 767px) {\r\n  /* On small screens, the nav menu spans the full width of the screen. Leave a space for it. */\r\n  .body-content {\r\n    padding-top: 50px;\r\n  }\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main